import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProjectCard from "./ProjectCard"; // Assumes ProjectCard component is reusable


const Portfolio = ({ heading, projects }) => {

    if (!projects || projects.length === 0) {
        return <div>No projects available</div>;
    }

    return (

        <div style={{paddingTop:"3rem",paddingBottom:"3rem"}}>
            <Container fluid style={{ padding: "0", margin: "0" }}>
                {/*<h2 className="text-center mb-5" style={{ color: "#333" }}>{heading}</h2>*/}
                <h2 className="display-4 pb-5 text-center">{heading}</h2>
                <Row className="g-0">
                    {projects.map((project, index) => (
                        <Col xs={12} md={6} key={`project-col-${index}`} style={{ padding: "0px" }}>
                            <ProjectCard id={`project-${index}`} value={project} />
                        </Col>
                    ))}
                </Row>

            </Container>
        </div>
    );
};

export default Portfolio;

// Usage example:
// import React from "react";
// import FullscreenGrid from "./FullscreenGrid";
//
// const dummyProjects = [
//   { name: "Project 1", description: "Description 1", svn_url: "#" },
//   { name: "Project 2", description: "Description 2", svn_url: "#" },
//   { name: "Project 3", description: "Description 3", svn_url: "#" },
//   { name: "Project 4", description: "Description 4", svn_url: "#" },
// ];
//
// const App = () => (
//   <FullscreenGrid heading="My Portfolio" projects={dummyProjects} />
// );
//
// export default App;
